import { FaqQuestion, StoreSection } from './components';
import { ImageValue, AbstractLocalizedValue } from './values';

export type SysReqBlockTemplate = 'req-min' | 'req-full';

export interface AbstractBlock {
  _id: string;
  module: string;
  components: any[];
  values: any;
  version?: 1;
}

export interface FaqBlock extends AbstractBlock {
  _id: string;
  components: FaqQuestion[];
  module: 'faq';
  values: {
    questionMode: { enable: boolean };
    title: AbstractLocalizedValue;
    background: ImageValue;
    template: 'horizontal';
    private: string[];
  };
}

export type StoreImageSizes = 'contain' | 'cover';

export enum StoreSizeTemplate {
  MEDIUM = 'medium',
  SMALL = 'small',
}

export interface StoreBlock {
  _id: string;
  module: 'store';
  components: StoreSection[];
  values: {
    background: ImageValue;
    title: AbstractLocalizedValue;
    description: { enable: boolean };
    enable: boolean;
    cardSize: StoreSizeTemplate;
  };
}

export type NewsBlockTemplate = 'mixed' | 'horizontal' | 'small' | 'slider';
export type NewsBlock = {
  components: [
    {
      components: [];
      enable: boolean;
      type: 'launcher_select';
      value: string;
      _id: string;
    }
  ];
  module: 'news';
  values: {
    title: AbstractLocalizedValue;
    description: AbstractLocalizedValue;
    background: ImageValue;
    template: NewsBlockTemplate;
    enable: boolean;
  };
} & AbstractBlock;
